import { ComplianceRequest } from './compliances.component';

export const ELEMENT_DATA: ComplianceRequest[] = [
  {
    id: 5,
    // cliente: 'Brain (Contrato 12/2025)',
    createdBy: 'exemplo@exemplo.com',
    createdDate: new Date('2024-04-25T18:35:27-03:00'),
    accountingDate: new Date('2024-04-25T18:35:27-03:00'),
    status: {
      code: 'VALIDATING_INPUT',
      description: 'Validando dados de entrada DataSafra',
    },
    originalFileGcsBucket: '',
    originalFileGcsName: '',
    originalFileName: null,
    finalFileGcsBucket: null,
    finalFileGcsName: null,
    uniqueTerritoryFieldKey: '',
    producerIdFieldKey: '',
    identityDocumentFieldKey: '',
    error: null,
    lastModifiedBy: 'exemplo@exemplo.com',
    featureCount: 3,
    requestedAndExecutedReportsCount: 4000,
  },
  {
    id: 7,
    // cliente: 'Brain (Contrato 12/2025)',
    createdBy: 'exemplo@exemplo.com',
    createdDate: new Date('2024-04-25T18:35:27-03:00'),
    accountingDate: new Date('2024-04-25T18:35:27-03:00'),
    status: {
      code: 'COMPLETED',
      description: 'Análise Concluída',
    },
    originalFileGcsBucket: '',
    originalFileGcsName: '',
    originalFileName: null,
    finalFileGcsBucket: null,
    finalFileGcsName: null,
    uniqueTerritoryFieldKey: '',
    producerIdFieldKey: '',
    identityDocumentFieldKey: '',
    error: null,
    lastModifiedBy: 'exemplo@exemplo.com',
    lastModifiedDate: new Date('2024-04-25T20:35:27-03:00'),
    featureCount: 3,
    requestedAndExecutedReportsCount: 4000,
  },
  {
    id: 10,
    // cliente: 'Brain (Contrato 12/2025)',
    createdBy: 'exemplo@exemplo.com',
    createdDate: new Date('2024-04-25T18:35:27-03:00'),
    accountingDate: new Date('2024-04-25T18:35:27-03:00'),
    status: {
      code: 'FAILED',
      description: 'Solicitação Cancelada pela Geoambiente',
    },
    originalFileGcsBucket: '',
    originalFileGcsName: '',
    originalFileName: null,
    finalFileGcsBucket: null,
    finalFileGcsName: null,
    uniqueTerritoryFieldKey: '',
    producerIdFieldKey: '',
    identityDocumentFieldKey: '',
    error: 'teste',
    lastModifiedBy: 'exemplo@exemplo.com',
    lastModifiedDate: new Date('2024-04-25T20:35:27-03:00'),
    featureCount: 3,
    requestedAndExecutedReportsCount: 4000,
  },
];
